import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import { ForgotSecretUP } from "@components/utils/Auth";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { usePostLoginHandler } from "@hooks/usePostLoginHandler";
import { useTranslation } from "react-i18next";

interface ForgotSecretStepProps extends OnboardingStepProps {}

const ForgotSecretStep = ({ navigate, handleClose, layout }: ForgotSecretStepProps) => {
  const { t } = useTranslation();
  const { forgotFlowHandlers } = usePostLoginHandler({
    flowMode: "dialog",
  });

  return (
    <OnboardingDialogLayout
      layout={layout}
      drawerTitle={t("forgot password")}
      pageTitle={t("forgot password")}
      navigation={{
        close: {
          onClick: handleClose,
        },
        back: {
          onClick: () => navigate(OnboardingDialogStep.Onboarding),
        },
      }}
      features={{
        showCloseButton: true,
        showBackButton: true,
      }}
    >
      <ForgotSecretUP onLoginSuccess={forgotFlowHandlers.handleLoginSuccess} />
    </OnboardingDialogLayout>
  );
};

export default ForgotSecretStep;
